import { Atom } from 'AppReact';
import styled from 'styled-components';

const template = styled.img`
    width: 14px;
    height: 14px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 0.375rem;
    margin-left: 0.375rem;
`

export default Atom({ type: 'image', datatype: 'string', template })